/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kn_Health_Checked_AtInputs */

const cs_kn_health_checked_at = /** @type {(inputs: Kn_Health_Checked_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrola`)
};

const en_kn_health_checked_at = /** @type {(inputs: Kn_Health_Checked_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checked`)
};

/**
* | output |
* | --- |
* | "Checked" |
*
* @param {Kn_Health_Checked_AtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const kn_health_checked_at = /** @type {((inputs?: Kn_Health_Checked_AtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kn_Health_Checked_AtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kn_health_checked_at(inputs)
	return cs_kn_health_checked_at(inputs)
});